import { FormattedMessage as FM } from "react-intl";

const TitleSection = ({ title, children }) => {
  return (
    <div className="flex md:space-x-[10px] space-x-2 tablet:space-x-3 items-center mb-3">
      <span>{children}</span>
      <h2 className="font-bold md:text-[20px] text-lg">
        <FM id={title} />
      </h2>
    </div>
  );
};

export default TitleSection;
